module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "inspector"
    }
  }, [_c('section', {
    staticClass: "list",
    attrs: {
      "id": "geometry-list"
    }
  }, [_vm._l((_vm.currentStoryGeometry.faces), function(face) {
    return (!_vm.currentSpace && !_vm.currentShading) ? [_c('header', [_c('h3', [_vm._v("Face " + _vm._s(face.id))])]), _vm._v(" "), _vm._l((face.edgeRefs), function(edgeRef) {
      return _c('div', {
        staticClass: "list-item"
      }, [_vm._v("\n        edge " + _vm._s(edgeRef.edge_id) + " " + _vm._s(edgeRef.reverse ? 'reversed ' : '') + "\n        "), _c('br'), _vm._v("startpoint " + _vm._s(_vm.startpoint(edgeRef)) + "\n        "), _c('br'), _vm._v("endpoint " + _vm._s(_vm.endpoint(edgeRef)) + "\n      ")])
    })] : _vm._e()
  }), _vm._v(" "), (_vm.currentSubSelectionFace) ? [_c('header', [_c('h3', [_vm._v("Face " + _vm._s(_vm.currentSubSelectionFace.id) + " on " + _vm._s(_vm.currentSpace ? _vm.currentSpace.name : _vm.currentShading.name))])]), _vm._v(" "), _vm._l((_vm.currentSubSelectionFace.edgeRefs), function(edgeRef) {
    return _c('div', {
      staticClass: "list-item"
    }, [_vm._v("\n        edge " + _vm._s(edgeRef.edge_id) + " " + _vm._s(edgeRef.reverse ? 'reversed ' : '') + "\n        "), _c('br'), _vm._v("startpoint " + _vm._s(_vm.startpoint(edgeRef)) + "\n        "), _c('br'), _vm._v("endpoint " + _vm._s(_vm.endpoint(edgeRef)) + "\n      ")])
  })] : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-73ec12ee!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Inspector.vue
// module id = 754
// module chunks = 2